const storageKeys = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  tenantId: "tenantId"
};

function setToken({ accessToken, refreshToken }) {
  localStorage.setItem(storageKeys.accessToken, accessToken);
  localStorage.setItem(storageKeys.refreshToken, refreshToken);
}

function getAccessToken() {
  return localStorage.getItem(storageKeys.accessToken);
}

function getRefreshToken() {
  return localStorage.getItem(storageKeys.refreshToken);
}

function clearToken() {
  localStorage.removeItem(storageKeys.accessToken);
  localStorage.removeItem(storageKeys.refreshToken);
}

function setTenantId(tenantId) {
  localStorage.setItem(storageKeys.tenantId, tenantId);
}

function getTenantId() {
  return localStorage.getItem(storageKeys.tenantId);
}

export default {
  setToken,
  getAccessToken,
  getRefreshToken,
  clearToken,
  setTenantId,
  getTenantId
};
